import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/soulhx-styles.scss';
import { App } from './components/App.js';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import * as serviceWorkerRegistration from './serviceWorkerRegistration.js';
import './i18n.js';
import { store, updateNewVersionReload } from '@soulhx/client-store';

const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
let waitingServiceWorker: ServiceWorker | null = null;

(window as Window & { skipWaitingAndReload?: () => void }).skipWaitingAndReload = () => {
  if (waitingServiceWorker) {
    waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
  } else {
    window.location.reload();
  }
};

// to fix the blank reloading screen issue
let refreshing = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    waitingServiceWorker = registration.waiting;
    store.dispatch(updateNewVersionReload(true));
  },
});
